import { isApp, isAppIOS } from './tools';
import { getStatusBarHeight, customCall, customRegister } from '@lhb/bridge';
import { getVersion } from '@lhb/bridge';

/**
 *
 * @returns {Number} 手机状态栏高度
 */
export function statusBarHeight() {
  return new Promise((resolve, reject) => {
    if (!isApp()) { // 非app环境
      return resolve(0);
    }

    const callBackFun = (height: string | number) => {
      if (+height > 0) {
        height = +height;
        resolve(height);
      } else {
        reject(0);
      }
    };
    if (isAppIOS()) { // 注意坑！lhb/bridge中使用的是getStatusBarHeight事件名，而ios用的是getStatusHeight事件名
      customCall('getStatusHeight', '', callBackFun);
    } else {
      getStatusBarHeight(callBackFun);
    }
  });
}

/**
 *
 * @returns {String} App版本号
 */
export function getAppVersion() {
  return new Promise((resolve) => {
    if (!isApp()) { // 非app环境
      return resolve(0);
    }

    const callBackFun = (version: string) => {
      resolve(version);
    };
    if (isAppIOS()) { // 注意坑！lhb/bridge中使用的是getVersion事件名，而ios用的是appVersion事件名
      customCall('appVersion', '', callBackFun);
    } else {
      getVersion(callBackFun);
    }
  });
}

/**
 * 获取应用是否开启了消息推送
 * @returns {Boolean} 是否开启了消息推送
 */
export function pushSettingStatus() {
  return new Promise((resolve, reject) => {
    if (!isApp()) { // 非app环境
      return reject();
    }

    const callBackFun = (status: boolean) => {
      if (status) {
        resolve(true);
      } else {
        reject();
      }
    };
    customCall('isPushSettingOn', '', callBackFun);
  });
}

/**
 * 跳转至应用设置消息推送页面
 */
export function jumpPushSetting() {
  return new Promise((resolve, reject) => {
    if (!isApp()) { // 非app环境
      return reject();
    }

    customCall('jumpPushSetting', '', () => resolve(true));
  });
}

/**
 * 打开微信客服
 */
export function jumpWechatService(params?: any) {
  return new Promise((resolve) => {
    if (!isApp()) { // 非app环境
      return resolve(0);
    }
    customCall('service', params, () => resolve(true));
  });
}

/**
 * 刷新H5
 */
export function refreshH5(callFn: Function) {
  return new Promise((resolve, reject) => {
    if (!isApp()) reject('非APP环境内，无法调用刷新事件');
    // const callBackFun = () => (resolve(true));
    customRegister('refreshH5', callFn);
  });
}

/**
 * 定位信息
 * @description app 获取定位的限制：同时多次请求只会获取一次，其他的请求会无响应，所以最好不要同时多次获取定位
 * @params {Object} 入参：{ openSystemPermission: 0 代表只获取定位  1 代表去开启定位权限 }
 * @returns Object {
 *   POIName: '',
 *   address: '' // 详细地址
 *   city: '' // 城市名
 *   cityCode: '', // code
 *   district: '',
 *   districtCode: '',
 *   province: '',
 *   lat: // 纬度
 *   lng: // 经度
 * }
 */
export function locationLngLat(params?: any) {
  if (!isApp()) { // 非app环境
    throw new Error('请在App中使用该方法');
  }
  return new Promise((resolve, reject) => {
    const callBackFun = (info: string) => {
      if (info && typeof (info) === 'string') {
        resolve(JSON.parse(info));
      } else {
        reject(params && params.openSystemPermission === 1 ? '开启定位权限失败' : `未获取到经纬度`);
      }
    };
    customCall('openMapLocation', params ? JSON.stringify(params) : '', callBackFun);
  });
}

/**
 * 跳转系统页面
 * @params json 入参 { type: 'push'/'locate'}
 * @returns boolean  true开/false关
 */
export function openSystemPermission(params?: any) {
  if (!isApp()) { // 非app环境
    throw new Error('请在App中使用该方法');
  }
  return new Promise((resolve) => {
    const callBackFun = (status: boolean) => {
      console.log('status', status);
      resolve(status);
    };
    customCall('openSystemPermission', params ? JSON.stringify(params) : '', callBackFun);
  });
}

/**
 * 通过桥接事件获取token
 * @returns Object {
 *  token // 老的php项目使用的token，目前只有老的项目使用
 *  uimsToken // java项目使用的token
 * }
 */
export function getAfferentToken(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!isApp()) reject();
    const callBackFun = (info: string) => {
      if (info && typeof (info) === 'string') {
        resolve(JSON.parse(info));
      } else {
        reject();
      }
    };
    customCall('getToken', {}, callBackFun);
  });
}

/*
  状态栏设置颜色（目前只支持切换文字颜色）
   * params: {
      isTextBlack: bool // true 黑字 false 白字
    }
*/
export function statusBarColor(params: any): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!isApp()) reject();
    const callBackFun = (info: string) => {
      if (info && typeof (info) === 'string') {
        resolve(JSON.parse(info));
      } else {
        reject();
      }
    };
    customCall('statusBarColor', params, callBackFun);
  });
}


/**
 * 跳转至原生自助选址场地列表
 */
export function goPlaceList(params: { cityId: number}) {
  return new Promise((resolve, reject) => {
    if (!isApp()) { // 非app环境
      return reject();
    }

    customCall('goPlaceList', params, () => resolve(true));
  });
}

/**
 * 通过桥接事件打开扫一扫
 */
export function openScan(option = {
  title: '', // 展示标题
  content: '扫描摄像头背面的二维码 即刻绑定设备', // 扫描提示
  hasInput: true, // 是否有手动输入按钮
  inputTip: '扫不出？尝试一下手动输入' // 手动输入提示文案
}, callback:Function): Promise<void> {
  return new Promise((resolve, reject) => {
    if (!isApp()) reject();
    customCall('zxing', option, callback);
  });
}

/**
 * 感知手动输入
 */
export function needHandInput(callback: Function) {
  return new Promise((resolve, reject) => {
    if (!isApp()) reject('非APP环境内，无法调用刷新事件');
    customRegister('zxingManualInout', callback);
  });
}

/**
 * 打开手机客流拍摄页面。
 * 原生返回事件的处理逻辑将在后续需求中接入，当前仅按约定完成事件注册与页面唤起。
 */
export function checkSpotCamera(params: {
  projectId: number | string;
  type: 'shootVideo' | 'chooseVideo';
  rangeStartTime?: string;
  rangeEndTime?: string;
}, callback: Function) {
  return new Promise((resolve, reject) => {
    if (!isApp()) {
      return reject('非APP环境内，无法调用手机拍摄事件');
    }
    // customRegister('checkSpotCamera', noop);
    customCall('checkSpotCamera', params, callback);
    resolve(true);
  });
}

/**
 * 播放踩点宝设备实时视频
 */
export function connectCamera(deviceId, callback: Function) {
  return new Promise((resolve, reject) => {
    if (!isApp()) reject('非APP环境内，无法调用刷新事件');
    customCall('connectCamera', { deviceId }, callback);
  });
}

/**
 * 播放踩点宝设备实时视频
 * 0926 新增入参 isSleep awakeTimestamp
 * @isSleep 表示是否休眠
 * @awakeTimestamp 需要唤醒的时间，对应拍摄任务详情中机位的realStart（真实拍摄时间）
 */
export function playRealTimeVideo(params, callback: Function) {
  return new Promise((resolve, reject) => {
    if (!isApp()) reject('非APP环境内，无法调用刷新事件');
    customCall('playCameraRealVideo', params, callback);
  });
}

/**
 * 获取踩点宝设备实时视频的封面
 */
export function getRealTimeVideoCover(deviceId, callback: Function) {
  return new Promise((resolve, reject) => {
    if (!isApp()) reject('非APP环境内，无法调用刷新事件');
    customCall('playCameraCover', { deviceId }, callback);
  });
}
/**
 * 踩点宝确认角度桥接事件
 */
export function playCameraAngle({ deviceId, type, taskId, isGaussianBlur = false }, callback: Function) {
  return new Promise((resolve, reject) => {
    if (!isApp()) reject('非APP环境内，无法调用刷新事件');
    customCall('playCameraAngle', { deviceId, type, taskId, isGaussianBlur }, callback);
  });
}

/**
 * 鹰眼确认角度桥接事件
 * 0926 新增两个参数
 * @isSleep 表示是否休眠
 * @awakeTimestamp 需要唤醒的时间，对应拍摄任务详情中机位的realStart（真实拍摄时间）
 */
export function playCameraAngleYinYan(params, callback: Function) {
  return new Promise((resolve, reject) => {
    if (!isApp()) reject('非APP环境内，无法调用刷新事件');
    // 联系电话，原生app内报错时提示用
    customCall('playCameraAngle', { ...params, contactPhone: '18342205756' }, callback);
  });
}

/**
 * 鹰眼不确认角度直接画框页桥接事件
 */
export function cameraDrawRect(params, callback: Function) {
  return new Promise((resolve, reject) => {
    if (!isApp()) reject('非APP环境内，无法调用刷新事件');
    customCall('cameraDrawRect', params, callback);
  });
}

/**
 * 进入踩点宝绘制页面强制横屏
 */
export function forceHorizontal(flag: boolean = true) {
  return new Promise((resolve, reject) => {
    if (!isApp()) { // 非app环境
      return reject();
    }

    customCall('rotateScreen', flag, () => resolve(true));
  });
};

/**
 * 安卓-是否禁用掉手势返回
 * @param url 要拦截的url
 * @param isGoBack 是否进行返回
 * @returns 返回一个Promise，用户触发了手势的回调
 * ！！！ 该用法不要写在组件里，一定要写在所引用组件顶层的entry文件里统一管理
 */
export function banBackIntercept(url:string, isGoBack:boolean) {
  // ！！！ 该用法不要写在组件里，一定要写在所引用组件的entry文件里统一管理
  return new Promise((resolve, reject) => {
    // ！！！ 该用法不要写在组件里，一定要写在所引用组件的entry文件里统一管理
    if (!isApp()) reject('非APP环境内，无法调用刷新事件');
    // ！！！ 该用法不要写在组件里，一定要写在所引用组件的entry文件里统一管理
    customCall('backIntercept', JSON.stringify({ url, isGoBack }), (userBack) => { resolve(userBack); });
  });
}

/**
 * 是否是OPPO平台
 * @returns 'oppo'
 */
export function isOPPOPlatform() {
  return new Promise((resolve, reject) => {
    if (!isApp()) reject('非APP环境内');
    // customCall('getChannel', JSON.stringify({ url, isGoBack }), (userBack) => { resolve(userBack); });
    const callBackFun = (str: string) => {
      if (str) {
        resolve(str);
      } else {
        reject('');
      }
    };
    customCall('getChannel', '', callBackFun);
  });
}

/**
 * 踩点宝设备操作
 * @type 1休眠，2连接
 * @deviceId 设备id
 */
export function deviceOperation(params, callback?: Function) {
  return new Promise((resolve, reject) => {
    if (!isApp()) reject('非APP环境内，无法调用刷新事件');
    customCall('deviceOperation', params, callback);
  });
}

/**
 * 退出登录
 */
export function bridgeLogout() {
  return new Promise((resolve, reject) => {
    const callback = (data) => {
      if (data) {
        resolve(data);
      } else {
        reject('');
      }
    };
    if (isApp()) {
      customCall('logout', '', callback);
    } else {
      resolve('');
    }
  });
}

/**
 * 播放反馈音（敲木鱼 / 外部音频）
 * @param {Object} params 入参对象
 * @param {string} [params.innerVoice] 内置声音标识，如 'muyu' 敲木鱼
 * @param {string} [params.voiceUrl] 外部音频链接；App 端有缓存机制，命中缓存直接播放，否则下载并缓存
 * @returns {Promise<any>} App 端回调透传
 */
export function playFeedback(params: { innerVoice?: string; voiceUrl?: string }) {
  return new Promise((resolve, reject) => {
    // 非 app 环境直接 reject
    if (!isApp()) return reject('非APP环境内，无法调用');
    customCall('playFeedback', params, (info: any) => resolve(info));
  });
}

/**
 * 触发 App 震动反馈
 * @returns {Promise<any>} App 端回调透传
 */
export function vibrateFeedback() {
  return new Promise((resolve, reject) => {
    // 非 app 环境直接 reject
    if (!isApp()) return reject('非APP环境内，无法调用');
    customCall('vibrateFeedback', {}, (info: any) => resolve(info));
  });
}

/**
 * 监听 App 切换到后台事件
 * @param {Function} callback App 切到后台时触发的回调
 * @returns {Promise<void>} 仅在非 App 环境 reject；注册成功不立即 resolve（与 refreshH5 行为对齐）
 */
export function onAppBackground(callback: Function) {
  return new Promise((resolve, reject) => {
    // 非 app 环境直接 reject
    if (!isApp()) return reject('非APP环境内，无法调用');
    customRegister('onAppBackground', callback);
  });
}
